import { useMemo, useState } from 'react';
import { useGameClient } from './hooks/useGameClient.js';
import { useGameStore } from './state/store.js';
import { DebugOverlay } from './ui/DebugOverlay.js';
import { TileTooltip } from './ui/TileTooltip.js';
import { Minimap } from './ui/Minimap.js';
import { Toolbar } from './ui/Toolbar.js';

const randomSeed = (): number => Math.floor(Math.random() * 0xffffffff);

export const App = (): React.JSX.Element => {
  const [seed, setSeed] = useState<number>(20260712);
  const options = useMemo(
    () => ({ seed, mapWidth: 192, mapHeight: 192 }),
    [seed],
  );
  const { containerRef, client } = useGameClient(options);
  const ready = useGameStore((s) => s.ready);

  return (
    <div className="app">
      <div className="viewport" ref={containerRef} />
      {!ready && <div className="loading">Generating world…</div>}
      <Toolbar seed={seed} onRegenerate={(): void => setSeed(randomSeed())} />
      <DebugOverlay />
      <TileTooltip />
      <Minimap client={client} />
    </div>
  );
};
